import React from 'react';
import Collapse from '@material-ui/core/Collapse';
import Paper from './layouts/Paper';
import { connect } from 'react-redux';

const mapStateToProps = (store, props) => ({
  open: store.state.banners[props.id] || false
});

function Banner(props) {
  return (
    <Collapse in={props.open}>
      <Paper backgroundColor="palette.error.light">{props.children}</Paper>
    </Collapse>
  );
}

export default connect(mapStateToProps)(Banner);
